// --- ETAPA FINAL DE CONFIGURAÇÃO ---
const LOGGING_FUNCTION_URL = "https://logerror-flrdxmgkwa-uc.a.run.app";
const SYSTEM_VERSION = "1.0.0";

const sessionId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
let lastAction = "Navegação inicial";

if (typeof window !== 'undefined') {
  window.addEventListener('click', (e) => {
    const target = e.target;
    if (target) {
      // CORREÇÃO: Tratamento seguro para extração de classe (evita erro em elementos SVG)
      const className = typeof target.className === 'string' 
        ? target.className 
        : (target.getAttribute && target.getAttribute('class')) || '';
        
      const safeClass = className ? '.' + className.split(' ')[0] : '';
      const safeText = target.innerText ? '(' + target.innerText.substring(0, 20) + '...)' : '';
      
      lastAction = `Clique em: ${target.tagName} ${target.id ? '#' + target.id : ''} ${safeClass} ${safeText}`.trim();
    }
  }, { capture: true });
}

export const logErrorToService = (level, portalName, error, userInfo = null, type = 'JS_ERROR', reactStack = null) => {
  if (!LOGGING_FUNCTION_URL || LOGGING_FUNCTION_URL.includes("SEU-HASH")) {
    console.error("URL da função de logging não configurada.");
    return;
  }

  const now = new Date();
  const dateStr = new Date(now.getTime() - (now.getTimezoneOffset() * 60000)).toISOString().split('T')[0];
  const timeStr = now.toTimeString().split(' ')[0];

  const logPayload = {
    level,
    portal: portalName,
    type,
    message: error instanceof Error ? error.message : String(error),
    stack: error instanceof Error ? error.stack : null,
    reactStack,
    timestamp: now.toISOString(),
    date: dateStr,
    time: timeStr,
    url: window.location.href,
    userAgent: navigator.userAgent,
    version: SYSTEM_VERSION,
    sessionId,
    lastAction,
    userInfo: userInfo ? {
      uid: userInfo.uid,
      email: userInfo.email,
      name: userInfo.displayName || "N/A"
    } : null,
  };

  try {
    fetch(LOGGING_FUNCTION_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(logPayload),
      keepalive: true,
      credentials: 'omit',
    });
  } catch (e) {
    // Fallback passivo
  }
};